// extracted by mini-css-extract-plugin
module.exports = {"container":"_dt","item":"_du","itemSingle":"_dv","itemContainer":"_dw","icon":"_dx","title":"_dy","text":"_dz","link":"_dA"};